import { render, staticRenderFns } from "./CommodityManage.vue?vue&type=template&id=9c6de850&scoped=true"
import script from "./CommodityManage.vue?vue&type=script&lang=js"
export * from "./CommodityManage.vue?vue&type=script&lang=js"
import style0 from "./CommodityManage.vue?vue&type=style&index=0&id=9c6de850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6de850",
  null
  
)

export default component.exports